import { useMutation } from "@apollo/client/react"; import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import ResultadoPH from "../../ResultadoPH";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_PROCEDIMIENTO_PRESENCIAL_AE, { adaptAddVisitaPresencialAEProcedimientoInput } from "../../../../../../data/graphQL/mutations/Visitas/saveProcedimientoPresencialAE";
import SAVE_ALMACENAMIENTO_PRESENCIAL_AE, { adaptAddVisitaPresencialAEAlmacenamientoInput } from "../../../../../../data/graphQL/mutations/Visitas/saveProcedimientoAlmacenamientoPresencialAE";
import { useStepSave } from "../../../../hooks/useStepSave";

import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function ProcedimientoPresencialAE2({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [saveProcedimiento] = useMutation(SAVE_PROCEDIMIENTO_PRESENCIAL_AE);
  const [saveAlmacenamiento] = useMutation(SAVE_ALMACENAMIENTO_PRESENCIAL_AE);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const formattedGroups = useMemo(() => {
    return groups.map((group) => {
      const formattedInputs = group.inputs.
        map((input) => {
          const newInput = { ...input };

          //Ahora listResultadoPH no es requerido en ningun momento. si no hay listResultadoPH, observaciones es obligatorio
          // if (input.name === "listResultadoPH") {
          //   if (formData.controlPH === true && formData.cambioSonda !== true) {
          //     newInput.required = true;
          //   } else {
          //     newInput.required = false;
          //   }
          // }

          switch (input.name) {
            case "observaciones":
              newInput.required = !!formData.solicitaRXControl || !formData?.listResultadoPH?.length;
              break;
          }

          if (esUrgencia) newInput.required = false;

          if (readOnly) newInput.disabled = true;

          return newInput;
        }).
        filter(Boolean);

      return { ...group, inputs: formattedInputs };
    });
  }, [
    readOnly,
    esUrgencia,
    formData?.solicitaRXControl,
    formData.listResultadoPH
  ]
  );

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedGroups, formData });

    const [procedimientoResult, almacenamientoResult] = await Promise.all([
      await saveProcedimiento({ variables: { input: adaptAddVisitaPresencialAEProcedimientoInput(formData) } }),
      await saveAlmacenamiento({ variables: { input: adaptAddVisitaPresencialAEAlmacenamientoInput(formData) } })]
    );

    const idPresencialAEProc = procedimientoResult?.data?.saveVisitaPresencialAEProcedimiento?.idPresencialAE;
    const idPresencialAEAlma = almacenamientoResult?.data?.saveVisitaPresencialAEAlmacenamiento?.idPresencialAE;
    if (!idPresencialAEProc || !idPresencialAEAlma) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData
    }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'procedimientoPresencialAE2',
      stepName: 'Procedimiento',
      formattedGroups
    });
  }, [onExposeFormatted, formattedGroups]);

  return (
    <>
      {formattedGroups.map((group, groupIndex) =>
        <CardBox key={groupIndex} title={group.title || undefined}>
          <Grid container spacing={2}>
            {group.inputs.
              filter((input) => !input.hidden).
              map((input) =>
                <Grid size={{ xs: input.halfSpace ? 6 : 12 }} key={input.name}>
                  {input.name === 'listResultadoPH' && <ResultadoPH
                    key={`${input.name}-${input.type}`}
                    value={formData[input.name]}
                    handleChangeList={handleChange}
                    readOnly={readOnly} />
                  }
                  {input.name !== 'listResultadoPH' && <RenderInputByTypeMobile
                    input={input}
                    key={`${input.name}-${input.type}${input.type === 'multiple_boolean' ? formData[input.name] : ''}`}
                    value={formData[input.name]}
                    handleChange={handleChange}
                    row={input.type === 'multiple_boolean'} />
                  }
                </Grid>
              )}
          </Grid>
        </CardBox>
      )}
    </>);

}

const groups = [
  {
    inputs: [
      {
        name: "listResultadoPH",
        displayName: "Resultado de PH",
        type: "int",
        disabled: true, //TODO Deshabilitado por el momento. Revisar funcionamiento

        min: 0,
        max: 14
      },
      {
        name: "solicitaRXControl",
        displayName: "Solicita RX de control",
        type: "boolean",
        lightTitle: true,
        required: true
      },
      {
        name: "observaciones",
        displayName: "Observaciones",
        type: "long_string",
        maxLength: 4000
      }]

  }];